// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCWVdOO0NXlHClvwpCQgBmWzx1uyARvvJw",
  authDomain: "multa-zero-teste.firebaseapp.com",
  projectId: "multa-zero-teste",
  storageBucket: "multa-zero-teste.appspot.com",
  messagingSenderId: "16299537096",
  appId: "1:16299537096:web:e27440727e3213ef662bfd",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };
